import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DealersOtaPageComponent } from './dealers-ota-page.component';

const routes: Routes = [
  {
    path: 'dealers-ota',
    data: { name: 'Dealers OTA', isTab: false },
    component: DealersOtaPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DealersOtaPageRoutingModule {}
